import Partner from './Partner';

export default Partner
export { Partner as Base }
